<template>
  <div>
    <StockAdjustmentViewModal />
  </div>
</template>
<script>
import StockAdjustmentViewModal from "@/components/widgets/Modals/StockAdjustmentViewModal";
export default {
  name: "StockAdjustmentsActions",
  components: {
    StockAdjustmentViewModal
  }
};
</script>